export default {
  p: {
    prgtitle: "SMART-TEAM-DEV-PORTAL [RU]",
    homepageTitleGC: "SMART-TEAM-DEV-PORTAL",
    homepageTitleGES: "PORTAL",
    homepageIcon: {icopathGC: "gc/gcLogo", colorGC: "black|white", icopathGES: "gc/gesLogo", colorGES: "black|white"},
    programVersion: "Версия программы: ",
    loremipsumdolor: "Сколько стоит килограм сушёных гвоздей, если Ёжику 6 лет...",
    moredetailed: "Подробнее",
    loadingdata: "Загрузка данных",
    savingdata: "Сохранение данных",
    processing: "Обработка...",
    lookingUpDnsName: "Ищу DNS-имя сервера",
    finish: "Готово",
    error: "Ошибка",
    warning: "Предупреждение",
    send: "Отправить",
    sendMeCode: "Отправить мне код",
    changetheme: "Сменить цветовую тему",
    userpage: "Параметры пользователя",
    online: "Онлайн",
    offline: "Оффлайн",
    usrexit: "Выйти",
    usrlogin: "Войти",
    fieldlogin: "Логин / Телефон",
    fieldpass: "Пароль",
    buttonlogin: "Войти",
    buttonclose: "Закрыть",
    collapseExpand: "Развернуть",
    buttonExpandWindow: "Развернуть окно",
    buttonCollapseWindow: "Свернуть окно",
    authFormTitle: "Форма авторизации пользователя",
    redirection: "Перенаправление...",
    undo: "Отменить",
    redo: "Повторить",
    back: "Назад",
    forward: "Вперед",
    copy: "Копировать",
    paste: "Вставить",
    cut: "Вырезать",
    help: "Справка",
    homebuttontitle: "Главная страница",
    mainmenutitle: "Главное меню",
    preview: "Предпросмотр",
    selectItems: "Выберите элементы",
    standartQuestion: "Стандартный вопрос",
    removeItems: "Удалить эти элементы из БД",
    adminTools: "Инструменты администратора",
    replaceThumbnailPhotoInAD: "Заменить миниатюру изображения в ActiveDirectory",
    showRecordset: "Посмотреть запись",
    editRecordset: "Редактировать запись",
    createRecordset: "Создать запись",
    createCopyOfRecordset: "Создать копию записи",
    removeRecordset: "Удалить запись",
    removeRecordsetFromDatabase: "Удалить запись из базы окончательно",
    restoreRemovedRecordset: "Восстановить удаленную запись",
    setAsArchival: "Пометить запись как архивную",
    unsetAsArchival: "Восстановить запись из архива",
    disableUser: "Отключить Пользователя",
    enableUser: "Включить Пользователя",
    disableGroup: "Отключить Группу",
    enableGroup: "Включить Группу",
    unlockUser: "Разблокировать Пользователя",
    unbanUser: "Разбанить Пользователя",
    replaceStatusToOnline: "Установить статус онлайн",
    replaceStatusToOffline: "Установить статус оффлайн",
    showUserActionsHistory: "Посмотреть историю действий пользователя",
    userAttributesWillBeChanged: "Следующие атрибуты будут изменены у пользователя ",
    selectGroupMembers: "Выбрать участников Группы",
    removeSelectedUserFromGroup: "Удалить выбранного Пользователя из Группы",
    showInstalledPrograms: "Показать установленные программы",
    showInstalledPrinters: "Показать установленные принтеры",
    showProcesses: "Показать запущенные процессы",
    getWindowsOfficeActivationStatus: "Получить состояние активации Windows и Office",
    activateWindowsOffice: "Активировать Windows и Office",
    ipConfigFlushDns: "Очистить кеш DNS",
    turnOffTheComputer: "Выключить компьютер",
    getScreenshotFromRemoteComputer: "Скриншот рабочего стола",
    openInBrowser: "Открыть в браузере",
    sendBallunMessageToComp: "Отправить всплывающее сообщение на компьютер пользователя",
    sendMessageToUserEmail: "Отправить сообщение на Email",
    sendMessageToUserViber: "Отправить сообщение в Viber",
    sendMessageToUserTelegram: "Отправить сообщение в Telegram",
    sendMessageToUserMattermost: "Отправить сообщение в Mattermost",
    srvbgAppWillRestart: "Изменение периода запуска служб 'ActiveDirectorySync' (syncADInterval) или 'compareUsersPhoto' (syncPhotoInterval) или 'clearOldUploads' приведет к перезапуску программы 'srvbg-app' после сохранения настроек!",
    srvbgSyslogWillRestart: "Включение или отключение службы 'SysLogServer' приведет к перезапуску программы 'srvbg-syslog'",
    portalAppWillRestart: "Изменение периода запуска службы 'clearOldUploads' приведет к перезапуску программы 'smartteamdev' после сохранения настроек!",
    srvbgHikWillRestart: "Изменение периода синхронизации с 'SKUD-SERVER' приведет к перезапуску программы 'srvbg-skud'",
    active: "Активно",
    notActive: "Не активно",
    enabled: "Включено",
    disabled: "Выключено",
    locked: "Заблокировано",
    lockedEditDel: "Заблокировано от удаления и изменения",
    unlocked: "Разблокировано",
    adGroup: "Группа домена",
    fbaGroup: "Настраиваемая группа",
    adUser: "Пользователь домена",
    fbaUser: "Внешний пользователь",
    guest: "Гость",
    banned: "Забанен",
    usermenu: [
      { key: "changelng", label: "Change Language" },
      { key: "changetheme", label: "Сменить тему" },
      { key: "changecompact", label: "Компактный интерфейс" },
      { key: "about", label: "О программе" },
      { key: "exit", label: "Выход из Приложения" }
    ]
  },
  e: {
    pageNotfoundOrDenied: "Страница не найдена или Вы не имеете достаточных прав",
    accessDenied: "Доступ запрещен",
    userDontHaveAnougthRight: "Вы не имеете достаточных прав",
    dbDenied: "Доступ к базе данных запрещен", // not used
    nullLoginOrPass: "Отсутствуют требуемые аргументы - login & pass",
    userLoggedFailed: "Ошибка авторизации",
    incorrectOldPassword: "Неправильный старый пароль",
    unknowErrorWhileReactElementsBuilding: "Неизвестная ошибка при построении компонентов React",
    exportError: "Ошибка экспорта",
    cantFindTableRowWithKey: "Не могу найти строку таблицы с key = ",
    unknownError: "Неизвестная ошибка",
    somethingWrong: "Что-то пошло не так",
    recIsNotFoundInDB: "Запись не найдена в базе данных",
    yandexMapsIsNotLoaded: "Модуль Yandex-карт не был загружен. Возможно он отключен Администратором",
    fileNotFound: "Файл не найден",
    cryptoError1: "Не удалось расшифровать данные с сервера. Неверный Ключ или Initialization Vector!"
  },
  w: {
    enterOnlyLoginBeforeSendCode: "Пожалуйста, введите только логин или телефон, прежде чем получить код",
    allowedFileTypes: "Вы можете загружать только следующие типы файлов: ",
    maxFileSizeError: "Размер файла должен быть не более ",
    selectOnlyOneRow: "Выберите только одну строку",
    NotApplicableToThisTable: "Не применимо к этой таблице",
    nothingSelected: "Ничего не выбрано",
    needToSelectMoreThanOne: "Необходимо выбрать более 1 элемента",
    incorrectDataFormat: "Неверный формат данных",
    nameFieldRequiredBeforeGenerateLogin: "Поле 'Имя' должно быть заполнено перед авто-созданием логина!",
    loginFieldAlreadyFilled: "Поле 'логин' уже запонено. Сотрите значения перед авто-генерацией нового значения",
    mailFieldAlreadyFilled: "Поле 'e-mail' уже запонено. Сотрите значения перед авто-генерацией нового значения",
    passFieldAlreadyFilled: "Поле 'пароль' уже запонено. Сотрите значения перед авто-генерацией нового значения",
    thisNameAlreadyExistInAD: "Это имя пользователя уже существует! Введите новое значение",
    thisLoginAlreadyExistInAD: "Этот логин пользователя уже существует! Введите новое значение",
    userLoginAlreadyExist: "Пользователь с таким Логином / sAMAccountName уже существует",
    groupAlreadyExist: "Такая Группа уже существует",
    userNameAlreadyExist: "Пользователь с таким Именем уже существует",
    cantRemoveTheLastRow: "Не могу удалить последнюю строку",
    errFields1: "Не все поля заполнены корректно",
    serverReturnedEmptyArray: "Сервер вернул пустой массив",
    passIsNull: "Поле 'пароль' не заполнено",
    newPassIsNull: "Поле 'новый пароль' не заполнено",
    newPass2IsNull: "Поле 'повтор пароля' не заполнено",
    passTooShort: "Поле 'пароль' слишком короткое",
    newPassTooShort: "Поле 'новый пароль' слишком короткое (должно быть минимум 6 символов)",
    passMastHave: "Пароль должен содержать буквы (заглавные и строчные), цифры и хотя бы один знак (- # $ ! @ &)",
    passwordsMismatch: "Пароли не совпадают",
    cantModifyADgroupUsers: "В этом приложении нельзя менять состав группы ActiveDirectory. Воспользуйтесь приложением 'Группы домена' или 'Пользователи домена'",
    cantModifyLockedUser: "Не могу изменять / удалять Защищенных пользователей. Можно только отключать / включать этих пользователей или менять у них пароль",
    cantModifyADgroup: "В этом приложении нельзя изменять или удалять группы ActiveDirectory",
    cantRemoveADuser: "В этом приложении нельзя удалять пользователей ActiveDirectory. Воспользуйтесь оснасткой ActiveDirectory на Контроллере Домена",
    cantModifyLockedRecordset: "Не могу изменить / удалить защищенную запись",
    recordsetDoesntExistInDB: "Такая Запись не существует в базе данных",
    sameFileAlreadyExistInUploads: "Файл с таким именем уже существует в Uploads",
    contragentAlreadyExist: "Контрагент с таким именем и ИНН уже существует в базе данных",
    employeeAlreadyExist: "Сотрудник с такими данными уже существует в базе данных",
    recordsetAlreadyExist: "Такая запись уже существует в базе данных",
    recordsetSimmilarAlreadyExist: "Вы изменили Запись так, что значения полей совпали с другой уже существующей записью в базе данных!",
    recordsetAlreadyInRecycleBin: "Запись уже находится в Корзине",
    noSelectedrecordsetsInRecycleBin: "Не выбрано ни одной удаленной записи",
    recordsetAlreadyIsArchival: "Запись уже является Архивной",
    recordseIsNotArchival: "Запись не является Архивной",
    copyingIsProhibited: "Копирование данных запрещено",
    notYetDeveloped: "Еще не доработано..."
  },
  i: {
    codeHasBeenSent: "Код отправлен",
    userLoggedSuccess: "Вы успешно авторизовались",
    successDeleted: "Удалено успешно",
    successUpdated: "Успешно Обновлено",
    successCreated: "Создано успешно", // not used
    successOperation: "Завершено успешно", // not used
    nothingHasChanged: "Ничего не измененилось",
    messageHasBeenSent: "Сообщение отправлено",
    messageWillBeSentAfterSaveForm: "Сообщение пользователям будет отправлено после нажатия на кнопку 'Сохранить'",
    finish: "Готово"
  },
  q: {
    doYouWantRemoveTheseItems: "Вы хотите удалить эти элементы?",
    doYouWantReplaceThumbnailPhoto: "Хотите заменить миниатюры изображений в ActiveDirectory для 00 выбранных пользователей?",
    doYouWantSwitchStatusToOnline: "Хотите переключить статус на онлайн?",
    doYouWantSwitchStatusToOffline: "Хотите переключить статус на оффлайн?",
    doYouWantToCreateUser: "Вы хотите создать нового AD-Пользователя ",
    doYouWantDisableSelectedUser: "Вы хотите отключить выбранного пользователя?",
    doYouWantEnableSelectedUser: "Вы хотите включить выбранного пользователя?",
    doYouWantDisableSelectedGroup: "Вы хотите отключить группу ",
    doYouWantEnableSelectedGroup: "Вы хотите включить группу ",
    doYouWantUnlockSelectedUser: "Вы хотите разблокировать выбранного пользователя (после ввода им неверного пароля много раз)?",
    doYouWantToRemoveSelecctedUsersFromSelectedGroup: "Вы хотите удалить выбранных Пользователей из Группы",
    doYouWantAddUsersToGroup: "Вы хотите добавить пользователей в Группу",
    doYouWantRemoveUsersFromGroup: "Вы хотите удалить пользователей из Группы",
    doYouWantRemoveGroup: "Вы хотите удалить Группу пользователей ",
    doYouWantRemoveUser: "Вы хотите удалить Пользователя ",
    doYouWantRemoveThisRecordset: "Вы хотите удалить эту запись?",
    doYouWantRemoveTheseRecordsets: "Вы хотите удалить эти записи?",
    doYouWantRemoveTheseRecordsetsFromDB: "Вы хотите удалить эти записи из базы данных?",
    doYouWantRestoreTheseRecordsets: "Вы хотите восстановить эти записи?",
    doYouWantMarkTheeseRecordsAsArchival: "Вы хотите пометить эти записи как Архивные?",
    doYouWantRestoreTheeseRecordsFromArchival: "Вы хотите восстановить эти записи из Архива?",
    gptForgetContext: "Начать новую беседу (забыть контекст текущей беседы)?",
    resetAppSettings: "Сбросить настройки приложения 'appname' на стандартные из файла 'apps/appname/index.js'?"
  },
  unit: {
    pcs: "шт",
    m: "м",
    m2: "м²",
    m3: "м³",
    mm: "мм",
    kg: "кг"
  },
  ag: {
    sideBarColumnsTitle: "Столбцы",
    sideBarFiltersTitle: "Фильтры",
    autoWidthColumns: "Авто-ширина столбцов",
    quickChart: "Быстрый график",
    online: "В сети",
    onlinev: "В сети (Пользователь проверен)",
    offline: "Не в сети",
    deprecated: "Устарел или сломан",
    setQuickFilter: "Установить быстрый фильтр по этому значению",
    resetFilters: "Сбросить все фильтры",
    excelExport: "Экспорт в Excel",
    jsonExport: "Экспорт в JSON",
    dhcpDinamic: "DHCP dynamic",
    dhcpStatic: "DHCP static",
    ovpn: "OVPN",
    ipsec: "IPSEC",
    vpn: "VPN",
    l2tp: "L2TP",
    pptp: "PPTP",
    device: "Устройство",
    comp: "Компьютер / Ноутбук",
    phone: "Телефон",
    tablet: "Планшет",
    printer: "Принтер",
    mfu: "МФУ",
    router: "Роутер / Маршрутизатор",
    registrator: "Регистратор",
    camera: "Камера",
    server: "Сервер",
    unknown: "Неизвестный",
    group: "Группировать",
    ungroup: "Разгруппировать",
    synology: "Synology DiskStation",
    windowsserver: "Windows сервер / компьютер",
    webserver: "Web сервер",
    otherserver: "Другой сервер",
    connection: "Подключение",
    fsowin: "FSO-Windows",
    fsoweb: "FSO-WEB",
    portal: "Портал",
    webservice: "WEB-сервис",
    otheraction: "Другое действие",
    disabledUser: "Пользователь отключен",
    enabledUser: "Пользователь включен",
    deleteRow: "Удалить строку",
    addRow: "Добавить строку"
  },
  gpt: {
    userDoesntHaveEnoughRightsToWorkWithGPT: "Вы не имеете достаточных прав для анализа этой таблицы при помощи ChatGPT",
    userDoesntHaveEnoughRightsToRunVoiceCommands: "Вы не имеете достаточных прав для выполнения голосовых комманд",
    thereAreNoDataForAnalysis: "Нет данных для анализа",
    incorrectRequest: "Некорректный запрос",
    incorrectDatePeriod: "Некорректный период дат для построения запроса",
    speechRecognitionError: "Ошибка распознавания речи",
    speechRecognitionNull: "Нет записанного сообщения. Нечего распознавать",
    undefinedEmployee: "Не удалось определить о каких сотрудниках идет речь",
    undefinedCommand: "Команда не входит в перечень разрешенных действий. Ознакомьтесь с перечнем допустимых команд перед вызовом голосового помощника",
    noAnswerFromChatGPT: "Нет ответа от chatGPT",
    ansWasCopiedToBuffer: "Ответ AI скопирован в буфер",
    copyToBufferError: "Возникла ошибка при копировании в буфер обмена",
    voiceRecordingStart: "Идет запись голоса с микрофона",
    voiceRecordingStop: "Запись голоса остановлена",
    micPermissionsError: "Отсутствуют права доступа к микрофону вашего устройства",
    tooltip1: "Анализ данных при помощи ChatGPT",
    tooltip2: "Отдать голосовую команду",
    selectCompany: "Выберите фирму"
  },
  adusers: {
    title: "Пользователи Домена",
    headers: [
      { key: "name", title: "Имя пользователя" },
      { key: "status", title: "Статус" },
      { key: "thumbnailPhoto", title: "Фото" },
      { key: "sAMAccountName", title: "Логин", hidden: true },
      { key: "company", title: "Компания" },
      { key: "groups", title: "Группы", hidden: true, visfor: ["admins", "headship"] },
      { key: "phones", title: "Телефоны" },
      { key: "mail", title: "Email" },
      { key: "title", title: "Должность" },
      { key: "manager", hidden: true, title: "Руководитель" },
      { key: "description", title: "Описание" },
      { key: "department", title: "Подразделение" },
      { key: "office", hidden: true, title: "Офис" },
      { key: "lng", title: "Язык", hidden: true, visfor: ["admins", "headship"] },
      { key: "country", title: "Страна", hidden: true, visfor: ["admins", "headship"] },
      { key: "region", title: "Область", hidden: true, visfor: ["admins", "headship"] },
      { key: "city", title: "Город", hidden: true, visfor: ["admins", "headship"] },
      { key: "street", title: "Адрес", hidden: true, visfor: ["admins", "headship"] },
      { key: "distinguishedName", title: "Distinguished Name", hidden: true, visfor: ["admins"] },
      { key: "adNotes", title: "Заметки", hidden: true, visfor: ["admins", "headship"] },
      { key: "accountDisable", title: "Аккаунт отключен", hidden: true },
      { key: "lastLogon", title: "lastLogon", hidden: true, visfor: ["admins", "headship"] },
      { key: "pwdLastSet", title: "pwdLastSet", hidden: true, visfor: ["admins"] },
      { key: "badPasswordTime", title: "badPasswordTime", hidden: true, visfor: ["admins"] },
      { key: "badPwdCount", title: "badPwdCount", hidden: true, visfor: ["admins"] }
    ]
  },
  adusers_devices: {
    headers: [
      { key: "summarystatus", title: "Статус устройства" },
      { key: "devicetype", title: "Тип устройства", hidden: true },
      { key: "connectiontype", title: "Тип подключения", hidden: true },
      { key: "status", title: "Статус", hidden: true },
      { key: "devicename", title: "Имя устройства" },
      { key: "internalip", title: "Внутренний IP" },
      { key: "externalip", title: "Внешний IP", hidden: true },
      { key: "place", title: "Местоположение" },
      { key: "caption", title: "Описание" },
      { key: "lastOnlineTime", title: "Когда был онлайн" },
      { key: "login", title: "Логин пользователя", hidden: true }
    ]
  },
  adgroups: {
    title: "Группы Домена",
    headers: [
      { key: "sAMAccountName", title: "Имя группы"},
      { key: "memberOf", title: "Член других групп" },
      { key: "description", title: "Описание" }
    ]
  },
  addevices: {
    title: "Компьютеры Домена",
    headers: [
      { key: "status", title: "Статус" },
      { key: "name", title: "Имя устройства" },
      { key: "description", title: "Описание" },
      { key: "operatingSystem", title: "Операционная система" },
      { key: "sAMAccountName", title: "Логин пользователя", hidden: true },
      { key: "userName", title: "Имя пользователя" },
      { key: "lastLogon", title: "lastLogon", hidden: true, visfor: ["admins"] },
      { key: "pwdLastSet", title: "pwdLastSet", hidden: true, visfor: ["admins"] },
      { key: "badPasswordTime", title: "badPasswordTime", hidden: true, visfor: ["admins"] },
      { key: "badPwdCount", title: "badPwdCount", hidden: true, visfor: ["admins"] },
      { key: "distinguishedName", title: "distinguishedName", hidden: true, visfor: ["admins"] }
    ]
  },
  mikrotik: {
    title: "Устройства с Роутеров",
    headers: [
      { key: "summarystatus", title: "Статус устройства" },
      { key: "devicetype", title: "Тип устройства", hidden: true },
      { key: "connectiontype", title: "Тип подключения", hidden: true },
      { key: "status", title: "Статус", hidden: true },
      { key: "devicename", title: "Имя устройства" },
      { key: "login", title: "Логин пользователя" },
      { key: "userName", title: "Имя пользователя" },
      { key: "internalip", title: "Внутренний IP" },
      { key: "externalip", title: "Внешний IP", hidden: true },
      { key: "place", title: "Местоположение" },
      { key: "caption", title: "Описание", hidden: true },
      { key: "mac", title: "MAC-адрес", hidden: true, visfor: ["admins"] }
    ]
  },
  acsreporter: {
    title: "ACS Reporter",
    history: {
      forgetThisConversation: "Забыть этот разговор",
      headers: [
        {key: "strDate", title: "Дата"},
        {key: "message", title: "Начало беседы"}
      ]
    }
  },
  syslogserver: {
    title: "SyslogServer События",
    headers: [
      { key: "login", title: "Логин пользователя" },
      { key: "action", title: "Событие" },
      { key: "strDate", title: "Дата время" },
      { key: "syslogClientType", title: "Тип сервера" },
      { key: "actionType", title: "Тип действия" },
      { key: "serverName", title: "Имя сервера", hidden: true },
      { key: "name", title: "Имя пользователя" },
      { key: "devicetype", title: "Тип устройства", hidden: true },
      { key: "devicename", title: "Имя устройства" },
      { key: "connectiontype", title: "Тип соединения", hidden: true, visfor: ["admins", "headship"] },
      { key: "internalip", title: "Внутренний IP", hidden: true },
      { key: "externalip", title: "Внешний IP", hidden: true, visfor: ["admins", "headship"] },
      { key: "place", title: "Местоположение" }
    ],
    history: {
      forgetThisConversation: "Забыть этот разговор",
      headers: [
        {key: "strDate", title: "Дата"},
        {key: "message", title: "Начало беседы"}
      ]
    }
  },
  selectUsersGrid: {
    title: "Выбор пользователей",
    headers: [
      { key: "name", title: "Имя пользователя" },
      { key: "sAMAccountName", title: "Логин пользователя" },
      { key: "title", title: "Должность" },
      { key: "department", title: "Подразделение" }
    ]
  },
  usersettings: {
    title: "Настройки текущего пользователя"
  },
  programsettings: {
    knownIPAddresses: {
      headers: [
        {key: "ip", title: "Внешний IP"},
        {key: "internalip", title: "Внутренний IP"},
        {key: "address", title: "Местоположение"}
      ]
    },
    allowedExternalAccess: {
      headers: [
        {key: "ip", title: "Внешний/Внутренний IP"},
        {key: "comment", title: "Комментарий"}
      ]
    },
    knownVPNaddresses: {
      headers: [{key: "VPNinternalip", title: "Внутренние IP адреса VPN-подключений"}]
    },
    ADuserTemplates: {
      headers: [ // key, title["ru" | "en" | "tr"], groups, jobTitle, department, description, company, office, manager
        {key: "key", title: "key"},
        {key: "title_en", title: "Английское название шаблона"},
        {key: "title_ru", title: "Русское название шаблона"},
        {key: "title_tr", title: "Турецкое название шаблона"},
        {key: "groups", title: "Группы"},
        {key: "jobTitle", title: "Должность"},
        {key: "department", title: "Подразделение"},
        {key: "description", title: "Описание"},
        {key: "company", title: "Компания"},
        {key: "office", title: "Офис"},
        {key: "manager", title: "Руководитель"}
      ]
    },
    mikrotikDevices: {
      headers: [
        {key: "active", title: "Активен"},
        {key: "host", title: "Имя хоста"},
        {key: "version", title: "Версия OS Mikrotik"},
        {key: "username", title: "Пользователь"},
        {key: "password", title: "Пароль"}
      ]
    },
    sysLogServer_knownFileServers: {
      headers: [
        {key: "internalip", title: "Локальный IP-адрес"},
        {key: "serverName", title: "Имя сервера"},
        {key: "serverPath", title: "Начальный путь к папке"}
      ]
    },
    sysLogServer_knownExternalUsers: {
      headers: [
        {key: "login", title: "Логин в VPN подключении"},
        {key: "name", title: "Отображаемое имя"}
      ]
    },
    sysLogServer_ignoreFiles: {
      headers: [
        {key: "filemask", title: "Маска имени файла"}
      ]
    },
    sysLogServer_ignoreActions: {
      headers: [
        {key: "actionmask", title: "Маска события"}
      ]
    },
    appRoles: {
      headers: [
        {key: "role", title: "Роль"},
        {key: "enabled", title: "Активна"},
        {key: "title", title: "Название"},
        {key: "caption", title: "Описание"},
        {key: "groups", title: "Группы"},
        {key: "users", title: "Пользователи"}
      ],
      grheaders: [
        {key: "group", title: "Группа"},
        {key: "expired", title: "Истекает"}
      ],
      uheaders: [
        {key: "user", title: "Пользователь"},
        {key: "expired", title: "Истекает"}
      ]
    },
    appDatabases: {
      headers: [
        {key: "name", title: "База данных"},
        {key: "allow", title: "Разрешено по-умолчанию"},
        {key: "select", title: "Доступные поля базы по-умолчанию"},
        {key: "filters", title: "Фильтры по-умолчанию"},
        {key: "roles", title: "Исключения для отдельных ролей"}
      ],
      rheaders: [
        {key: "role", title: "Роль"},
        {key: "allow", title: "Что разрешено"},
        {key: "select", title: "Доступные поля базы"},
        {key: "filters", title: "Фильтры"}
      ]
    },
    emailSMTP: {
      headers: [
        {key: "name", title: "Имя (адрес почтового ящика)"},
        {key: "enabled", title: "Включен"},
        {key: "server", title: "Сервер"},
        {key: "port", title: "Порт"},
        {key: "user", title: "Пользователь"},
        {key: "pass", title: "Пароль"},
        {key: "rules", title: "Правила"}
      ],
      rulesHeaders: [
        {key: "useForRecipients", title: "Использовать для Получателей"},
        {key: "useIfSubject", title: "Использовать если Тема содержит"}
      ]
    },
    emailIMAP: {
      headers: [
        {key: "name", title: "Имя (адрес почтового ящика)"},
        {key: "autoCheckEnable", title: "Включить автопроверку"},
        {key: "server", title: "Сервер"},
        {key: "port", title: "Порт"},
        {key: "user", title: "Пользователь"},
        {key: "pass", title: "Пароль"},
        {key: "theOldestMailDate", title: "Проверять почту до этой даты (старейшая дата)"},
        {key: "rules", title: "Правила"}
      ],
      rulesHeaders: [
        {key: "subject", title: "Тема содержит"},
        {key: "from", title: "Отправитель"},
        {key: "body", title: "Тело письма содержит"},
        {key: "hasAttachments", title: "Есть вложения"},
        {key: "serverAction", title: "ServerAction"}
      ]
    }
  },
  chatgpt: {
    history: {
      forgetThisConversation: "Забыть этот разговор",
      headers: [
        {key: "strDate", title: "Дата"},
        {key: "message", title: "Начало беседы"}
      ]
    }
  },
  fbagroups: {
    title: "Группы пользователей портала",
    headers: [
      {key: "status", title: "Тип группы"},
      {key: "locked", title: "Заблокировано", hidden: true},
      {key: "enabled", title: "Активна/Нет", hidden: true},
      {key: "ad", title: "ActiveDirectory", hidden: true},
      {key: "group", title: "Группа"},
      {key: "description", title: "Описание"},
      {key: "_id", title: "_id", hidden: true, visfor: ["admins"]}
    ]
  },
  selectFBAUsersGrid: {
    title: "Выбор пользователей",
    headers: [
      {key: "login", title: "Логин пользователя"},
      {key: "name_ru", title: "Имя на русском"},
      {key: "name_en", title: "Имя на английском"}
    ]
  },
  fbausers: {
    title: "Пользователи портала",
    headers: [
      {key: "status", title: "Тип пользователя"},
      {key: "locked", title: "Заблокировано", hidden: true},
      {key: "banned", title: "Бан", hidden: true},
      {key: "enabled", title: "Включен/Отключен", hidden: true},
      {key: "ad", title: "ActiveDirectory", hidden: true},
      {key: "thumbnailPhoto", title: "Фото"},
      {key: "name", title: "Имя пользователя"},
      {key: "name_ru", title: "Имя на русском", hidden: true},
      {key: "name_en", title: "Имя на английском", hidden: true},
      {key: "login", title: "Логин", hidden: true},
      {key: "company", title: "Компания"},
      {key: "phones", title: "Телефоны"},
      {key: "mail", title: "Email"},
      {key: "title", title: "Должность"},
      {key: "description", title: "Описание"},
      {key: "activeDevices", title: "Активные устройства"},
      {key: "groups", title: "Группы", hidden: false},
      {key: "department", title: "Отдел", hidden: true},
      {key: "office", title: "Офис", hidden: true},
      {key: "manager", title: "Руководитель", hidden: true},
      {key: "country", title: "Страна", hidden: true},
      {key: "region", title: "Область", hidden: true},
      {key: "city", title: "Город", hidden: true},
      {key: "street", title: "Улица", hidden: true},
      {key: "viberid", title: "ViberID", hidden: true},
      {key: "viberEnabled", title: "Включить ViberBot", hidden: true},
      {key: "telegramid", title: "TelegramID", hidden: true},
      {key: "telegramEnabled", title: "Включить TelegramBot", hidden: true},
      {key: "mattermostid", title: "MattermostID", hidden: true},
      {key: "mattermostEnabled", title: "Включить MattermostBot", hidden: true},
      {key: "authtypes", title: "Разрешенные типы аутентификации", hidden: true, visfor: ["admins"]},
      {key: "lng", title: "Язык интерфейса", hidden: true, visfor: ["admins"]},
      {key: "theme", title: "Тема интерфейса", hidden: true, visfor: ["admins"]},
      {key: "compact", title: "Компактный интерфейс", hidden: true, visfor: ["admins"]},
      {key: "showDesktopIconsTitle", title: "Показывать заголовки значков на рабочем столе", hidden: true, visfor: ["admins"]},
      {key: "awailApps", title: "Доступные приложения", visfor: ["admins"]},
      {key: "desktopApps", title: "Приложения на рабочем столе", hidden: true, visfor: ["admins"]},
      {key: "_id", title: "_id", hidden: true, visfor: ["admins"]},
      {key: "lastLogon", title: "Last Logon date", hidden: true, visfor: ["admins"]},
      {key: "lastIP", title: "Last IP address", hidden: true, visfor: ["admins"]},
      {key: "pwdLastSet", title: "PWD last set", hidden: true, visfor: ["admins"]},
      {key: "badPasswordTime", title: "Bad password time", hidden: true, visfor: ["admins"]},
      {key: "badPwdCount", title: "Bad password count", hidden: true, visfor: ["admins"]}
    ],
    devsheaders: [
      {key: "type", title: "Тип"},
      {key: "devicename", title: "Устройство"},
      {key: "ip", title: "IP-адрес"}
    ]
  },
  api1c: {
    c1disabled: "Модуль API 1C отключен Администратором",
    c1LinkIsNull: "В настройках программы не указан URI для API 1C (oData)",
    c1AuthIsNull: "В настройках программы не указаны Учетные данные для API 1C (oData)",
    accessDenied: "Доступ к API 1C (oData) запрещен. Некорректные учетные данные",
    userIsntAnAccouter: "Операция не разрешена. Вы не относитесь к группе, имеющей доступ 1C",
    doYouWantMarkTheseRecsAsCarriedOutIn1C: "Желаете пометить эти записи, как ПРОВЕДЕННЫЕ в 1С-Бухгалтерии?",
    doYouWantMarkTheseRecsAsNotCarriedOutIn1C: "Желаете СНЯТЬ ОТМЕТКУ с записей о том, что они проведенны в 1С-Бухгалтерии?",
    theseRecsWillBeBlockedInPortal: "Записи будут заблокированы для изменения и удаления на Портале",
    theseRecsWillBeUnblockedInPortal: "Записи будут разблокированы для изменения и удаления на Портале",
    selectedRecordsWereMarkedAsCarriedOutIn1C: "Выбранные записи были отмечены как ПРОВЕДЕННЫЕ в 1С-Бухгалтерии",
    selectedRecordsWereUnmarkedAsCarriedOutIn1C: "С выбранных записей была снята отметка о проведении документа в 1С-Бухгалтерии"
  }
};
